import dataBase from '@/dataBase/database'
import { reportService } from '@/_services'
import { fileService } from './file.service'
import { motivationalReportService } from './motivationalReport.service'
import { authentication } from '../_store/authentication.module'
import { connectWebSocket } from './websocket'
class SyncManager {
  constructor() {
    this._store = null
  }

  init(store) {
    this._store = store;
    this.resetPendingPhotos()
    const handleOnline = async () => {
      this._store.dispatch('user/loadUser').then(data => {
        const offlineMode = localStorage.getItem('offlineMode');
        if (data.offlineMode != offlineMode) {
          this._store.dispatch('user/changeMode', offlineMode != null ? offlineMode : false);
        }
      });
      if (authentication.state.grants.length) {
        connectWebSocket(localStorage.getItem("LoginName"));
      }
      window.dispatchEvent(new CustomEvent('app:online-sync'));
    };

    const handleOffline = () => {
      localStorage.setItem('offlineMode', true)
      this._store.commit('user/setOfflineMode', true);
      window.dispatchEvent(new CustomEvent('app:online-sync'));
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    if (navigator.onLine) {
      handleOnline();
    } else {
      handleOffline();
    }
  }


  async resetPendingPhotos() {
    const pending = await dataBase.photos.where('synced').anyOf([4, 3]).toArray();
    for (const photo of pending) {
      await dataBase.photos.update(photo.id, { synced: 0, offline: true });
    }
    console.log(`[SyncManager] Сброшено ${pending.length} зависших фото`);
  }

  async syncAll() {
    if (!navigator.onLine) return

    this._store.commit('pointreport/setLoadingAsync', true)
    try {
      let totalReportData = await dataBase.productReportData.where('synced').equals(0).count()
      const pointReports = await dataBase.pointReport.where('synced').equals(0).toArray();
      let totalDmpReports = await dataBase.motivationalDmpReport.where('synced').equals(0).count()
      let unsyncedMotivationalDmp = await dataBase.motivationalDmp.where('synced').equals(0).count()
      const total = pointReports.length;

      if (totalReportData === 0 && pointReports.length === 0 && totalDmpReports === 0 && unsyncedMotivationalDmp === 0) return

      const weightMap = new Map();

      for (const pr of pointReports) {
        const pointId = String(pr.pointId);
        let totalPhotos = 0;

        totalPhotos += await dataBase.photos.where('reportId').equals(pointId).filter(p => p.synced === 0).count();

        const productReports = await dataBase.productReportData.where('pointId').equals(pointId).filter(p => p.synced === 0).toArray();
        for (const prod of productReports) {
          totalPhotos += await dataBase.photos.where('reportId').equals(String(prod.id)).filter(p => p.synced === 0).count();
        }
        const weightPerPhoto = totalPhotos > 0 ? 1 / (total * totalPhotos) : 0;
        weightMap.set(pointId, { totalPhotos, weightPerPhoto });
      }

      const progress = { done: 0, total }
      this._store.commit('pointreport/setSyncProgress', { ...progress })
      await this._syncDmpReports()
      await this._syncMotivationalDmp()
      await this._syncReportData(progress, weightMap)
      await this._syncPointReports(progress, weightMap)
    } catch (err) {
      console.error('[SyncManager]', err)
    } finally {
      this._store.commit('pointreport/setLoadingAsync', false)
    }
  }

  async _syncReportData(progress, weightMap) {
    let unsynced = await dataBase.productReportData.where('synced').equals(0).toArray()
    for (let item of unsynced) {
      const pointId = String(item.pointId);
      const info = weightMap.get(pointId);
      const weight = info ? info.weightPerPhoto : 0;
      let countPhotos = await dataBase.photos.where('reportId').equals(String(item.id)).filter(p => p.synced === 0).count()
      try {
        let uploadedPhotos = await this._uploadPhotos(item.id, progress, weight)
        await reportService.sendReportData({
          projectId: item.projectId,
          tradePointId: item.pointId,
          productId: item.productId,
          reportItemInfo: item.data,
          comment: item.data.comment,
          presense: item.data.presense,
          sync: true,
          frontPhotos: countPhotos,
          photos: uploadedPhotos,
        })

        let photos = await dataBase.photos.where('reportId').equals(item.id).filter(p => p.synced === 4).toArray()
        for (let photo of photos) {
          await dataBase.photos.update(photo.id, { offline: false, synced: 1 })
        }
        await dataBase.productReportData.update(item.id, { synced: 1 })
      } catch (err) {
        const photosToReset = await dataBase.photos.where('reportId').equals(String(item.id)).filter(p => p.synced === 4 || p.synced === 3).toArray();
        if (photosToReset.length > 0 && weight > 0) {
          for (const photo of photosToReset) {
            await dataBase.photos.update(photo.id, { offline: true, synced: 0 });
            progress.done -= weight;
          }
          this._store.commit('pointreport/setSyncProgress', { ...progress });
        }
        console.error(`[SyncManager] Ошибка reportData ${item.id}:`, err);
        
      }
    }
  }

  async _syncPointReports(progress, weightMap) {
    let unsynced = await dataBase.pointReport.where('synced').equals(0).toArray();
    for (let item of unsynced) {
      let pointId = String(item.pointId);
      let info = weightMap.get(pointId);
      let weight = info ? info.weightPerPhoto : 0;
      let totalPhotosForReport = info ? info.totalPhotos : 0;
      let uploadedPhotos = [];
      let countPhotos = await dataBase.photos.where('reportId').equals(String(item.pointId)).filter(p => p.synced === 0).count()
      uploadedPhotos = await this._uploadPhotos(String(item.pointId), progress, weight);
      try {
        await reportService.sendPreReport({
          projectId: item.projectId,
          tradePointId: item.pointId,
          comment: item.comment,
          tempPhotos: uploadedPhotos,
          reportPhoto: item.reportPhoto,
          frontPhotos: countPhotos,
          sync: true,
        });
        if (totalPhotosForReport === 0) {
          progress.done += 1 / progress.total;
          this._store.commit('pointreport/setSyncProgress', { ...progress });
        }
        let photos = await dataBase.photos.where('reportId').equals(String(item.pointId)).filter(p => p.synced === 4).toArray()
        for (let photo of photos) {
          await dataBase.photos.update(photo.id, { offline: false, synced: 1 })
        }
        await dataBase.pointReport.update(item.id, { synced: 1 });

      } catch (err) {
        if (totalPhotosForReport > 0) {
          const photosToReset = await dataBase.photos.where('reportId').equals(pointId).filter(p => p.synced === 4 || p.synced === 3).toArray();
          for (const photo of photosToReset) {
            await dataBase.photos.update(photo.id, { offline: true, synced: 0 });
            progress.done -= weight;
          }
          this._store.commit('pointreport/setSyncProgress', { ...progress });
        }
        console.error('Ошибка отправки отчёта:', err);
      }

      progress.done++;
      this._store.commit('pointreport/setSyncProgress', { ...progress });
    }
  }

  async _syncMotivationalDmp() {
    const unsynced = await dataBase.motivationalDmp.where('synced').equals(0).toArray()

    for(const dmp of unsynced) {
      try {
        let motivationalReportServerId
        const motivationalReport = await dataBase.motivationalReport.get(Number(dmp.localMotivationalReportId))
        if(!motivationalReport.serverId) {
          let motivationalReportData = await motivationalReportService.loadMyMotivation(motivationalReport.projectId, motivationalReport.networkId, motivationalReport.pointId)
          motivationalReportServerId = motivationalReportData.id
          await dataBase.motivationalReport.update(motivationalReportData.id, { serverId: data.id, synced: 1 })
        } else motivationalReportServerId = motivationalReport.serverId
        let data = await motivationalReportService.createDmp({ id: dmp.serverId, dmpCategory: dmp.dmpCategory, comment: dmp.comment }, motivationalReportServerId)
        await dataBase.motivationalDmp.update(dmp.id, { serverId: data.id, synced: 1 })
      } catch (error) {
        console.error(`[SyncManager] Ошибка motivationalDmp ${dmp.id}:`, error)
      }
    }
  }

  async _syncDmpReports(progress) {
    const unsynced = await dataBase.motivationalDmpReport.where('synced').equals(0).toArray()

    for (const report of unsynced) {
      let serverDmpId, reportId
      try {
        const dmp = await dataBase.motivationalDmp.get(Number(report.localDmpId))
        if (dmp.serverId) {
          serverDmpId = dmp.serverId
        } else {
          let motivationalReportServerId
          const motivationalReport = await dataBase.motivationalReport.get(Number(dmp.localMotivationalReportId))
          if(!motivationalReport.serverId) {
            let data = await motivationalReportService.loadMyMotivation(motivationalReport.projectId, motivationalReport.networkId, motivationalReport.pointId)
            motivationalReportServerId = data.id
            await dataBase.motivationalReport.update(dmp.id, { serverId: data.id, synced: 1 })
          } else motivationalReportServerId = motivationalReport.serverId
          let data = await motivationalReportService.createDmp({ id: dmp.serverId, dmpCategory: dmp.dmpCategory, comment: dmp.comment }, motivationalReportServerId)
          serverDmpId = data.id
          await dataBase.motivationalDmp.update(dmp.id, { serverId: serverDmpId, synced: 1 })
        }
        reportId = `${dmp.localMotivationalReportId}_${dmp.id}`;
        const uploadedPhotos = await this._uploadPhotos(reportId)
        await motivationalReportService.sendReportDmp(serverDmpId, {
          dmpCategory: report.dmpCategory, 
          reportPhoto: uploadedPhotos,
          sync: true
        })
        let photos = await dataBase.photos.where('reportId').equals(reportId).filter(p => p.synced === 4).toArray()
        for (let photo of photos) {
          await dataBase.photos.update(photo.id, { offline: false, synced: 1 })
        }
        await dataBase.motivationalDmpReport.update(report.id, { synced: 1 })

      } catch (err) {
        const photosToReset = await dataBase.photos.where('reportId').equals(reportId).filter(p => p.synced === 4 || p.synced === 3).toArray();
        if (photosToReset.length) {
          for (const photo of photosToReset) {
            await dataBase.photos.update(photo.id, { offline: true, synced: 0 });
          }
        }
        console.error(`[SyncManager] Ошибка motivationalDmpReport ${report.id}:`, err)
      }
    }
  }

  async _uploadPhotos(reportId, progress, weightPerPhoto) {
    let photos = await dataBase.photos.where('reportId').equals(String(reportId)).filter(p => p.synced === 0).toArray()
    let uploaded = []
    let duplicates = []
    for (let photo of photos) {
      try {
        let formData = new FormData()
        const blob = new Blob([photo.blob], { type: `image/${photo.extension}` });
        formData.append('files[]', blob, photo.fileName)

        let data = await fileService.uploadFiles(formData, photo.motivational ? true : false, photo.dmp && photo.motivational ? true : false, () => {})
        for(let ph of data){
          ph.dmp = photo.dmp
          if(ph.alreadyLoaded) {
            duplicates.push({
              uuid: ph.uuid,
              extension: ph.extension,
            })
            await dataBase.photos.update(photo.id, { offline: false, synced: 3 })
          } else {
            await dataBase.photos.update(photo.id, { offline: false, synced: 4 })
          }
        }
        if (progress && weightPerPhoto) {
          progress.done += weightPerPhoto;
          this._store.commit('pointreport/setSyncProgress', { ...progress });
        }
        uploaded.push(...data)
      } catch (err) {
        console.error(`[SyncManager] Ошибка загрузки фото ${photo.id}:`, err)
      }
    }
    this._store.commit('pointreport/setDuplicatesPhoto', duplicates)
    return uploaded
  }
}

export default new SyncManager()